<div class="relative bg-white overflow-hidden pb-8">
  <div class="mx-auto max-w-7xl relative px-4 sm:px-6 lg:px-0 z-10">
    <div class="flex flex-row w-full">
      <img-comparison-slider class="sm:h-96 w-full">
      <img loading="lazy" slot="first" [src]="blok.before_image?.filename" [alt]="blok.before_image?.alt" class="sm:h-96 w-full" />
      <img loading="lazy" slot="second" [src]="blok.after_image?.filename" [alt]="blok.after_image?.alt" class="sm:h-96 w-full" />
    </img-comparison-slider>
    </div>
  </div>
</div>